<template>
  <div>
    <v-menu
      v-if="menuItems.length"
      v-model="activate"
      :position-x="x"
      :position-y="y"
      absolute
      offset-y
    >
      <v-list dense>
        <v-tooltip
          v-for="(menuItem, index) in menuItems"
          :key="`contextMenuItem_${index}`"
          left
        >
          <template v-slot:activator="{ on }">
            <v-list-item
              v-show="menuItem.show"
              :disabled="menuItem.disabled"
              v-on="on"
              @click="menuItem.action"
            >
              <v-list-item-icon class="mr-2">
                <v-icon small :color="getIconColor(menuItem)">{{
                  menuItem.icon
                }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title :class="getTextColor(menuItem)">{{
                menuItem.title
              }}</v-list-item-title>
            </v-list-item>
          </template>
          <p style="color: white">
            {{ menuItem.message }}
          </p>
        </v-tooltip>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: ['noItemsMessage'],
  data() {
    return {
      activate: false,
      menuItems: [],
      x: 0,
      y: 0
    }
  },
  computed: {
    getNoItemsMessage() {
      return this.noItemsMessage || 'No items to show'
    }
  },
  methods: {
    open({ actions, x, y }) {
      this.activate = true
      this.x = x
      this.y = y

      if (actions.every((item) => !item.show)) {
        this.menuItems = [
          {
            show: true,
            title: this.getNoItemsMessage,
            action: () => {}
          }
        ]
      } else {
        this.menuItems = actions
      }
    },
    getIconColor(item) {
      if (item.disabled) return 'grey'
      return item.color
    },
    getTextColor(item) {
      if (item.disabled) return 'grey--text'
      return
    }
  }
}
</script>
